import React from "react";
import { Activity, ArrowRight, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function AizaleaUtilityHero() {
  return <section id="aizalea-utility-hero" className="relative min-h-[80vh] flex items-center bg-background bg-gradient-to-r from-white via-slate-100/70 to-slate-500/60 overflow-hidden pt-12 pb-16 !opacity-[1] lg:pt-16 lg:pb-24">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none flex items-center justify-center opacity-[0.03] mix-blend-multiply">
        <div className="w-full h-full bg-cover bg-center bg-no-repeat" />
      </div>

      {}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-ring/10 rounded-full blur-[120px] pointer-events-none -translate-y-1/2" />
    <div className="absolute top-0 right-0 w-[45%] h-full bg-gradient-to-l from-slate-400/35 via-slate-500/25 to-transparent pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div className="lg:col-span-7 flex flex-col items-start text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent/50 text-accent-foreground text-sm font-medium mb-8 border border-border/50 backdrop-blur-sm shadow-sm">
              <ShieldCheck className="w-4 h-4 text-ring" />
              <span>AizaHcare Ecosystem Infrastructure</span>
            </div>
            
            <h1 className="font-extrabold tracking-tight leading-[1.1] !text-4xl !text-[hsl(199,89%,48%)]">AIZALEA<br />Utility Token powering a Real AI Healthcare Infrastructure</h1>
            
            <p className="mt-6 text-lg sm:text-xl text-muted-foreground max-w-2xl leading-relaxed font-medium">AizaHcare AI-Native Self-Improving Healthcare Infrastructure.<br />Intelligence Loop: Patient → Data → AI → HCP → Better Care&nbsp;</p>
            
            <div className="mt-10 flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Button asChild size="lg" className="rounded-full h-14 px-8 text-base font-semibold shadow-lg shadow-ring/20 hover:shadow-ring/40 transition-all duration-300 hover:-translate-y-0.5">
                  <Link to="/#howtobuyaizalea">
                  Buy Aizalea Utility Token <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
              <Button asChild variant="ghost" size="lg" className="rounded-full h-14 px-8 text-base font-semibold border border-border/60 hover:bg-accent hover:text-accent-foreground transition-all duration-300">
                
              </Button>
            </div>

            <div className="mt-12 flex items-center gap-6 text-sm text-muted-foreground font-medium">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-ring animate-pulse" />
                MAIDA AI Compute Active
              </div>
              <div className="w-px h-4 bg-border" />
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-ring animate-pulse" />
                Real Patient Data Secured
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative flex justify-center lg:justify-end mt-12 lg:mt-0 perspective-[1000px]">
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[130%] h-[130%] bg-blue-700/30 blur-[120px] rounded-full pointer-events-none" />

            {}
     
          <div className="relative w-full aspect-[16/9] rounded-[2.5rem] bg-white/20 backdrop-blur-2xl shadow-[0_30px_60px_-15px_rgba(0,0,0,0.1),0_0_40px_rgba(59,130,246,0.15)] overflow-hidden group hover:-translate-y-3 transition-transform duration-700 ease-out transform-gpu">
  <video className="w-full h-full object-cover object-center scale-[1.02] rounded-[2rem] opacity-80 !bg-[url(https://positive-cattle.10web.cloud/wp-content/uploads/2026/03/fdde9dc0-4e47-4cdb-8137-a5ae5192f1a6.mov)]" autoPlay muted loop playsInline>
    <source src="https://positive-cattle.10web.cloud/wp-content/uploads/2026/03/fdde9dc0-4e47-4cdb-8137-a5ae5192f1a6.mov" type="video/mp4" />
  </video>

  <div className="absolute inset-0 bg-gradient-to-tr from-white/0 via-white/20 to-white/0 pointer-events-none opacity-60 mix-blend-overlay" />
  <div className="absolute bottom-0 right-6 w-16 h-16 bg-white/15 rounded-full blur-xl pointer-events-none" />
          </div>
          </div>

        </div>
      </div>
    </section>;
}